import { render, staticRenderFns } from "./mine-password.vue?vue&type=template&id=23be7e64&scoped=true&"
import script from "./mine-password.vue?vue&type=script&lang=js&"
export * from "./mine-password.vue?vue&type=script&lang=js&"
import style0 from "./mine-password.vue?vue&type=style&index=0&id=23be7e64&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be7e64",
  null
  
)

export default component.exports